import Vue from 'vue';
import DatesAndPricesContainer from "../HotelDetails/DatesAndPricesContainer.vue";
import OfferHotelCardPriceButtons from "../HotelDetails/OfferHotelCardPriceButtons.vue";
var initializeOfferCard = function () {
    new Vue({
        render: function (h) { return h(DatesAndPricesContainer); },
    }).$mount('#offerHotelCardDatesAndPrices');
    new Vue({
        render: function (h) { return h(OfferHotelCardPriceButtons); },
    }).$mount('#offerHotelCardPriceButton');
};
export default initializeOfferCard;
